exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show-table td[data-v-5c5daf60],.show-table th[data-v-5c5daf60]{padding:5px 30px}.image[data-v-5c5daf60]{height:190px;width:210px;cursor:pointer;margin:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}td[data-v-5c5daf60],tr[data-v-5c5daf60]{color:#000;font-size:1.1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c5daf60","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/actors/show.vue
// module id = MkND
// module chunks = 1